import '../../sass/blocks/custom/layout/_statistic.scss'
require('../../js/blocks/statistic.js');